import { useEffect, useState } from "react";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import Spinner from "../Spinner/Spinner";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

export default function LimitOverIncome() {
  const { userId } = useSelector((state) => state.Auth);
    const jwt_token = sessionStorage.getItem("jwt_token");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  let user = "";

  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [leftreferralApi, setleftreferralApi] = useState([]);

  const [search, setSearch] = useState(user);
  const [allMember, setAllMember] = useState(0);
  const [todate, setTodate] = useState("");
  const [formdate, setFromdate] = useState("");

  const referral_API = async () => {
    setisLoading(true);
    try {
       let responceRight = await API?.post(
              "/GetIncomeReports",
              {
                loginid: userId,
                uid: search,
                fdate: formdate,
                tdate: todate,
                type: "IncomeLimit",
              },
              {
                headers: {
                  Authorization: jwt_token,
                },
              }
            );
      console.log("Limitover", responceRight);
      responceRight = responceRight.data.data[0];
      setAllMember(responceRight?.length);
      setleftreferralApi([]);
      let arrayLeft = [];

      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index+ 1,
          user_id: `${item?.uid}`,
          incomelimit: item?.incomelimit,
          totalincome: item?.totalincome,
        });

        setleftreferralApi(arrayLeft);
      });
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const referral_API_Export = async () => {
    try {
      let responceRight = await API?.post(
       "/GetIncomeReports",
              {
                loginid: userId,
                uid: search,
                fdate: formdate,
                tdate: todate,
                type: "IncomeLimit",
              },
              {
                headers: {
                  Authorization: jwt_token,
                },
              }
      );

      responceRight = responceRight?.data?.data[0];

      let arrayLeft = [];
      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: item?.Row,
          user_id: `${item?.uid}`,
          incomelimit: item?.incomelimit,
          totalincome: item?.totalincome,
        });
      });

      const fileName = "LimitOverReport";
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const ws = XLSX.utils.json_to_sheet(arrayLeft);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    } catch (e) {
      console.log("Error While calling Myteam API", e);
    }
  };
  
  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost
  );

  var [my_team, set_my_team] = useState({
    cols: [
      { Header: "S.No.", accessor: "sr" },
      { Header: "User Id", accessor: "user_id" },
      { Header: "Income Limit", accessor: "incomelimit" },
      { Header: "Total Income", accessor: "totalincome" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="row">
            <div class="col-md-12">
              <div class="panel panel-primary">
                <div class="panel-heading">
                  <h4 class="panel-title">Limit Over Income Report</h4>
                </div>
                <div class="panel-body">
                  <div class="row">
                     <div class="col-md-3">
                        <input
                          class="form-control in-ip-1"
                          id="uid"
                          onChange={(e) => setSearch(e.target.value)}
                          name="uid"
                          placeholder="Search By User Id or Name or Email"
                          type="text"
                          value={search}
                        />
                      </div> 
                    {/* <div class="col-md-3">
                        <input
                          class="form-control in-ip-1"
                          onChange={(e) => setFromdate(e.target.value)}
                          value={formdate}
                          id="fdate"
                          name="fdate"
                          type="date"
                        />
                      </div> */}
                    {/* <div class="col-md-3">
                        <input
                          class="form-control in-ip-1"
                          onChange={(e) => setTodate(e.target.value)}
                          value={todate}
                          id="tdate"
                          name="tdate"
                          type="date"
                        />
                      </div> */}
                    <div class="col-md-3">
                        <input
                          type="reset"
                          id="btnsearch"
                          formmethod="get"
                          onClick={() => referral_API()}
                          class="btn btn-lg btn-primary"
                          value="Search"
                        />
                      </div>
                    <div class="col-md-3">
                      <input
                        type="reset"
                        id="btnsearch"
                        formmethod="get"
                        onClick={() => referral_API_Export()}
                        class="btn btn-lg btn-primary"
                        value="Export To Excel"
                      />
                    </div>
                  </div>
                  <div class="row">
                    {/* <b>
                        <p>Total Count: {allMember}</p>
                      </b> */}

                    {isLoading ? (
                      <Spinner />
                    ) : (
                      <div className="col-md-12">
                        <Table data={currentPostleft} columns={my_team.cols} />

                        <Table_Buttons
                          indexOfFirstPage={indexOfFirstPage}
                          indexOfLastPost={indexOfLastPost}
                          setcurrentPage={setcurrentPage}
                          currentPage={currentPage}
                          totalData={leftreferralApi.length}
                          listPerpage={listPerpage}
                          handleRowsPerPageChange={setlistPerpage}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
